module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_0_null.b60fcd1b.png";